module.exports = __webpack_public_path__ + "img/xzs_logo.bb1db592.png";